import {
  RegulatoryAddress,
  RegulatoryInformationForm,
  RegulatoryManagingPartnerForm,
  RegulatoryPhone,
} from 'types';
import { formatTimestamp } from 'helpers';

function formatBirthday(birthday: number | undefined) {
  if (!birthday) {
    return '';
  }

  const { day, month, year } = formatTimestamp(birthday);

  return `${day}${month}${year}`;
}

function phoneToString(phone: RegulatoryPhone | undefined) {
  if (!phone) {
    return '';
  }

  const { phoneNumberDDD, phoneNumber } = phone;

  return `${phoneNumberDDD}${phoneNumber}`;
}

function populateRegulatoryAddress(
  regulatoryAddressData: any = {}
): RegulatoryAddress {
  const {
    addressReferencePoint,
    cep,
    city,
    neighborhood,
    state,
    street,
    streetNumber,
  } = regulatoryAddressData;

  return {
    addressReferencePoint: addressReferencePoint || '',
    cep: cep || '',
    city: city || '',
    neighborhood: neighborhood || '',
    state: state || '',
    street: street || '',
    streetNumber: streetNumber || '',
  };
}

function populateRegulatoryManagingPartner(
  regulatoryManagingPartnerData: any = {}
): RegulatoryManagingPartnerForm {
  const {
    name,
    email,
    cpfCnpj,
    birthday,
    monthlyIncome,
    professionalOccupation,
    selfDeclaredLegalPresentative,
    phone,
    address,
  } = regulatoryManagingPartnerData;

  return {
    name: name || '',
    email: email || '',
    cpfCnpj: cpfCnpj || '',
    birthday: formatBirthday(birthday),
    monthlyIncome: monthlyIncome ? String(monthlyIncome) : '',
    phone: phoneToString(phone),
    selfDeclaredLegalPresentative:
      typeof selfDeclaredLegalPresentative === 'boolean'
        ? selfDeclaredLegalPresentative
        : null,
    professionalOccupation: professionalOccupation || '',
    address: populateRegulatoryAddress(address),
  };
}

export function regulatoryInformationFactory(
  params: any = {}
): RegulatoryInformationForm {
  const {
    vendorRegisterInformation,
    accountDigit,
    accountNumber,
    agencyCode,
    agencyDigit,
    bankCode,
    document,
  } = params;

  const {
    cpfCnpj,
    tradingName,
    name,
    annualRevenue,
    email,
    phone,
    address,
    managingPartner,
  } = vendorRegisterInformation || {};

  return {
    address: populateRegulatoryAddress(address),
    annualRevenue: annualRevenue ? String(annualRevenue) : '',
    cpfCnpj: cpfCnpj || '',
    name: name || '',
    phone: phoneToString(phone),
    tradingName: tradingName || '',
    email: email || '',
    managingPartner: populateRegulatoryManagingPartner(managingPartner),
    accountDigit: accountDigit || '',
    accountNumber: accountNumber || '',
    agencyCode: agencyCode || '',
    agencyDigit: agencyDigit || '',
    bankCode: bankCode || '',
    document: document || '',
  };
}
